var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.speedTabText},[_c('div',{class:_vm.$style.icon}),_vm._v(" "),_c('div',{class:_vm.$style.text},[_vm._v("\n    臻享服务\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }